module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--2--create-5240308b.jpg";